module.exports = __webpack_public_path__ + "media/images/device-mobile-icon-452678b485c08e8c1bd5155ba1c7da87.svg";